const Show = ({
  condition,
  children,
}: {
  condition: boolean;
  children: React.ReactNode;
}) => {
  if (condition) {
    return children;
  } else {
    return;
  }
};
export default Show;
